"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleRecaptchaLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class GoogleRecaptchaLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor(googleSiteKey) {
        super('GoogleRecaptcha', constants_1.LOAD_CONFIG);
        this.googleSiteKey = googleSiteKey;
    }
    getUrls() {
        return [constants_1.URL + this.googleSiteKey];
    }
    postLoad() {
        return new Promise((resolve, reject) => {
            try {
                window.grecaptcha.enterprise.ready(() => {
                    resolve();
                });
            }
            catch (_a) {
                reject();
            }
        });
    }
}
exports.GoogleRecaptchaLoader = GoogleRecaptchaLoader;
//# sourceMappingURL=index.js.map